import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CheckoutSettings } from '../../interfaces/checkout_settings';

/* eslint-disable */
interface CheckoutState {
  checkout_settings: CheckoutSettings[];
  current_checkout_setting: CheckoutSettings | null;
}

const safelyParseJSON = (localStorageKey: string) => {
  try {
    const data = localStorage.getItem(localStorageKey);
    return JSON.parse(data);
  } catch (error) {
    console.error(`Failed to parse data from ${localStorageKey}`, error);
    return null;
  }
};

const initialState: CheckoutState = {
  checkout_settings: [],
  current_checkout_setting: null,
};

const checkout = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setCheckouts(state, action: PayloadAction<CheckoutSettings[]>) {
      state.checkout_settings = action.payload;
    },
    setCurrentCheckoutSetting(state, action: PayloadAction<CheckoutSettings>) {
      state.current_checkout_setting = action.payload;
    },
    clear(state, action) {
      state.checkout_settings = null;
      state.current_checkout_setting = null;
    },
  },
});

export const { setCheckouts, setCurrentCheckoutSetting, clear } =
  checkout.actions;

export default checkout.reducer;
